import * as React from 'react';

import {AddressInfo} from '../types/addressTypes';
import ActionPopup from "./ActionPopup";
import RadioGroupInput from "./RadioGroupInput";

interface AddressConfirmationPopupProps {
  headingText: string;
  enteredAddressLabel: string;
  suggestedAddressLabel: string;
  editAddressBtnLabel: string;
  continueWithAddressBtnLabel: string;
  suggestedAddress: AddressInfo;
  enteredAddress: AddressInfo;
  onContinueWithAddress: Function;
  onEditAddress: Function;
  onCloseAddressConfirmation: Function;
  invalidAddressMsg?: React.ReactNode;
}

interface AddressConfirmationPopupState {
  selectedOption: string;
  selectedAddress: AddressInfo;
}
export default function AddressConfirmationPopup(
  props: AddressConfirmationPopupProps
) {
  const [state, setState] = React.useState<AddressConfirmationPopupState>({
    selectedOption: 'useSuggested',
    selectedAddress: props.suggestedAddress || props.enteredAddress
  });

  const suggestedAddressDescription = props.suggestedAddress && (
    <>
      <div>{props.suggestedAddress.addressLineOne}</div>
      {props.suggestedAddress.addressLineTwo && (
        <div>{props.suggestedAddress.addressLineTwo}</div>
      )}
      <div>
        {props.suggestedAddress.city},&nbsp;{props.suggestedAddress.state}&nbsp;
        {props.suggestedAddress.zip}
      </div>
    </>
  );

  const enteredAddressDescription = props.enteredAddress && (
    <>
      <div>{props.enteredAddress.addressLineOne}</div>
      {props.enteredAddress.addressLineTwo && (
        <div>{props.enteredAddress.addressLineTwo}</div>
      )}
      <div>
        {props.enteredAddress.city},{props.enteredAddress.state}&nbsp;
        {props.enteredAddress.zip}
      </div>
    </>
  );

  const options = [];
  if (enteredAddressDescription) {
    options.push({
      label: props.enteredAddressLabel,
      value: 'useEntered',
      description: enteredAddressDescription,
      hideRadio: !!props.invalidAddressMsg
    });
  }
  if (suggestedAddressDescription) {
    options.push({
      label: props.suggestedAddressLabel,
      value: 'useSuggested',
      description: suggestedAddressDescription
    });
  }

  return (
    <div className="addressConfirmation">
      <ActionPopup
        onPopupClose={props.onCloseAddressConfirmation}
        headingText={props.headingText}
        message={
          <>
            {props.invalidAddressMsg && (
              <div className="verifyMsg">{props.invalidAddressMsg}</div>
            )}
            <RadioGroupInput
              options={options}
              name="addressOptions"
              id="addressOptions"
              label="addressOptions"
              onChange={(event: any) => {
                setState({
                  ...state,
                  selectedOption: event.target.value,
                  selectedAddress:
                    event.target.value === 'useSuggested'
                      ? props.suggestedAddress
                      : props.enteredAddress
                });
              }}
              value={state.selectedOption}
            />
          </>
        }
        buttons={[
          { label: props.editAddressBtnLabel, onClick: props.onEditAddress },
          {
            label: props.continueWithAddressBtnLabel,
            type: 'primary',
            onClick: () => {
              props.onContinueWithAddress(state.selectedAddress);
            }
          }
        ]}
      />
    </div>
  );
}
